module.exports = __webpack_public_path__ + "img/impact-in-action-mobile@2x.906978d7.webp";